import { YieldType } from "../../../service/globalTypes";
import { setLastYieldSentAndTimestamp } from "../../../service/producerServices";
import { resetStylesForDataSentSuccessfully } from "../../../service/producerServices/resetStylesForDataSentSuccessfully";

export const handlePartialSuccessfulResend = ({ resendTryResults, row, bid, ask, currentErrorSentYields }) => {
  resendTryResults.forEach(({ yieldType, sentSuccessfully }) => {
    if (!sentSuccessfully) return;

    if (!currentErrorSentYields.includes(yieldType)) currentErrorSentYields.push(yieldType);
    const valueSent = yieldType === YieldType.BID ? bid : ask;

    resetStylesForDataSentSuccessfully({ sendedRow: row, yieldToReset: yieldType });
    setLastYieldSentAndTimestamp({ yieldType, value: valueSent, row: row - 1 });
  });
};
